export default class BaseEvaluator {
  fieldName: string;
  friendlyFieldName: string;
  value;
  model;
  mutator;
  isValid: boolean;
  evaluatorName: string;

  constructor(fieldName, friendlyFieldName, model, mutator = null) {
    this.fieldName = fieldName;
    this.friendlyFieldName = friendlyFieldName;
    this.value = model[fieldName];
    this.model = model; // Some evaluators rely on other values to validate (eg. before)
    this.mutator = mutator;
    this.isValid = false;
    this.evaluatorName = '';

    // It is possible to use a property path for the fieldName (e.g.: prop1.prop2.prop3)
    if (fieldName.indexOf('.') > -1) {
      this.value = model;
      const fragments = fieldName.split('.');
      let index = 0;
      while (index < fragments.length) {
        this.value = this.value[fragments[index]];
        index += 1;
      }
    }
  }

  validate() {
    this.isValid = true;
    return true;
  }

  getMessage(validatorDictionary) {
    if (this.isValid) {
      return {
        type: 'valid',
        message: '',
      };
    }
    const func = validatorDictionary[this.evaluatorName];
    return {
      type: 'error',
      message: func(this.friendlyFieldName, this.mutator),
    };
  }
}
